import makeStyles from '@material-ui/core/styles/makeStyles';
import { LayoutDirection } from 'features/app/ts/LayoutDirection';

interface Props extends LayoutDirection {
  isListOpened: boolean;
  isListActive: boolean;
};

export const useStyles = makeStyles(theme => ({
  sidebarItemWithListRoot: {
    overflow: 'hidden',
    perspective: 1,
    borderRadius: theme.spacing(8.5),
    marginBottom: theme.spacing(8),

    '&:hover div, &:hover button': {
      transition:
        'background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,fill 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
      backgroundColor: '#E5F7F7',
      color: theme.palette.primary.main,
      '& path, line': {
        fill: theme.palette.primary.main,
        stroke: theme.palette.primary.main,
      },
      '& .finance-icon': {
        fill: 'none !important',
      },
    },
  },
  listItem: {
    borderRadius: theme.spacing(8.5, 8.5, 0, 0),
    marginBottom: 0,
  },
  arrowIconContainer: {
    width: '100%',
    textAlign: ({ direction }: LayoutDirection) => direction === 'rtl' ? 'left' : 'right',

    '& > svg': {
      transform: ({ isListOpened }: Props) => `rotate(${isListOpened ? '180deg' : '0'})`,
    },
  },
  subListContainer: {
    transition: 'unset',
    backgroundColor: ({ isListActive }: Props) => (isListActive ? '#E5F7F7' : theme.palette.background.paper),
    color: ({ isListActive }: Props) => (isListActive ? theme.palette.primary.main : 'inherit'),
    borderRadius: theme.spacing(0, 0, 8.5, 8.5),
    paddingBottom: theme.spacing(7),
  },
  listSubItem: {
    margin: 0,
    // padding: theme.spacing(7, 0, 7, 44),
    padding: ({ direction }: LayoutDirection) => direction === 'rtl' ? theme.spacing(7, 0, 7, 25) : theme.spacing(7, 0, 7, 44),
    display: 'flex',
    alignItems: 'center',
  },
  subListItemText: {
    fontSize: theme.spacing(7.5),
    lineHeight: '23px',
  },
}));
